import { CUADERNO_BASE_PATH, CUADERNO_LABEL } from "@/lib/cuaderno-config";
import Link from "next/link";

export default function Footer() {
  return (
    <footer className="px-6 md:px-12 py-16 border-t border-border bg-white">
      <div className="max-w-5xl mx-auto">
        {/* Navegación principal */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-12">
          {/* Legal */}
          <div>
            <h3 className="font-medium text-text-primary mb-4">Legal</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/aviso-legal"
                  className="text-text-secondary hover:text-olive transition-colors"
                >
                  Aviso legal
                </Link>
              </li>
              <li>
                <Link
                  href="/privacidad"
                  className="text-text-secondary hover:text-olive transition-colors"
                >
                  Privacidad
                </Link>
              </li>
              <li>
                <Link
                  href="/cookies"
                  className="text-text-secondary hover:text-olive transition-colors"
                >
                  Cookies
                </Link>
              </li>
              <li>
                <Link
                  href="/terminos"
                  className="text-text-secondary hover:text-olive transition-colors"
                >
                  Términos y Condiciones
                </Link>
              </li>
            </ul>
          </div>

          {/* Producto */}
          <div>
            <h3 className="font-medium text-text-primary mb-4">Producto</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/"
                  className="text-text-secondary hover:text-olive transition-colors"
                >
                  Qué es Kaizen Feedback
                </Link>
              </li>
              <li>
                <Link
                  href="/como-funciona"
                  className="text-text-secondary hover:text-olive transition-colors"
                >
                  Cómo funciona
                </Link>
              </li>
              <li>
                <Link
                  href="/planes"
                  className="text-text-secondary hover:text-olive transition-colors"
                >
                  Planes y precios
                </Link>
              </li>
              <li>
                <Link
                  href={CUADERNO_BASE_PATH}
                  className="text-text-secondary hover:text-olive transition-colors"
                >
                  {CUADERNO_LABEL}
                </Link>
              </li>
            </ul>
          </div>

          {/* Acceso */}
          <div>
            <h3 className="font-medium text-text-primary mb-4">Acceso</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/sign-in"
                  className="text-text-secondary hover:text-olive transition-colors"
                >
                  Iniciar sesión
                </Link>
              </li>
            </ul>
          </div>

          {/* Empresa */}
          <div>
            <h3 className="font-medium text-text-primary mb-4">Empresa</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/contacto"
                  className="text-text-secondary hover:text-olive transition-colors"
                >
                  Contacto
                </Link>
              </li>
              <li>
                <a
                  href="mailto:hola@kaizenfeedback.com"
                  className="text-text-secondary hover:text-olive transition-colors"
                >
                  hola@kaizenfeedback.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-text-muted text-sm">
            © {new Date().getFullYear()} Kaizen Feedback
          </div>
          <p className="text-text-muted text-sm text-center md:text-right">
            Feedback privado para cafeterías y restaurantes
          </p>
        </div>
      </div>
    </footer>
  );
}
